import { sendHTTPRequest } from '@/util/http'
import { toolkitUrls } from '@/util/links'
import type { GenerateAccess, GeneratedAssessmentList } from './generated_assessment_types'

function savedPageUrl(savedPageUuid: string) {
  return `${toolkitUrls.api}/saved_pages/${encodeURIComponent(savedPageUuid)}`
}

// Uncached, unlike most reads: the person looking at the list adds and deletes its rows, and it is
// gated on folder membership, which can be revoked. Rethrows the HTTPError so a 404 can be read.
export async function getGeneratedAssessments(savedPageUuid: string): Promise<GeneratedAssessmentList> {
  const response = await sendHTTPRequest({
    url: `${savedPageUrl(savedPageUuid)}/generated_assessments`,
    method: 'GET',
    includeCredentials: true
  })
  return await response.json() as GeneratedAssessmentList
}

// One decision per page: the server answers from the page alone (owner, or edit on the folder), so
// every target gets the same answer. `goal` is sent only because the pair must be well formed.
export async function getGenerateAccess(savedPageUuid: string): Promise<GenerateAccess> {
  const response = await sendHTTPRequest({
    url: `${savedPageUrl(savedPageUuid)}/generate_access`,
    method: 'GET',
    urlParams: { target_type: 'goal' },
    includeCredentials: true
  })
  return await response.json() as GenerateAccess
}

// The endpoint answers 404 for "not permitted" as well as "missing", so callers get one
// failure and cannot tell the two apart.
export async function deleteGeneratedAssessment(uuid: string): Promise<void> {
  await sendHTTPRequest({
    url: `${toolkitUrls.api}/generated_assessments/${uuid}`,
    method: 'DELETE',
    includeCredentials: true
  })
}
